<template>
  <DialogWrapper
    class="export-dialog"
    titleI18nKey="admin.crm.title.campaign.micrositeFormExport"
    saveBtnLabelI18nKey="admin.crm.btn.campaign.export"
    close-on-cancel
    :closeOnClickModal="false"
    :show.sync="dialogShow"
    :loading="exporting"
    @save="handelExport"
  >
    <div class="dialog-container">
      <div class="info-item campaign-name">
        <span class="title">{{ $t('admin.crm.label.campaign.name') }}:</span>
        <span class="name">{{ campaignName }}</span>
      </div>
      <div class="info-item microsite-name">
        <span class="title">{{ $t('admin.crm.label.microsite.micrositeName') }}:</span>
        <span class="name">{{ micrositeName }}</span>
      </div>
      <div class="info-item select-time">
        <span class="title">{{ $t('admin.crm.label.campaign.dateRange') }}:</span>
        <el-date-picker
          class="date"
          type="daterange"
          value-format="yyyy-MM-dd"
          range-separator="-"
          v-model="timeRange"
          :clearable="false"
          :start-placeholder="$t('admin.crm.placeholder.campaign.startDate')"
          :end-placeholder="$t('admin.crm.placeholder.campaign.endDate')"
          :picker-options="pickerOptions"
        />
      </div>
    </div>
  </DialogWrapper>
</template>

<script>

import moment from 'moment'
import { mapActions } from 'vuex'
import DialogWrapper from '@/components/dialog/dialogWrapper.vue'

export default {
  components: {
    DialogWrapper
  },
  props: {
    show: {
      type: Boolean,
      required: true
    },
    siteId: {
      type: String,
      required: true
    },
    campaignName: {
      type: String,
      default: ''
    },
    micrositeName: {
      type: String,
      default: ''
    }
  },
  data () {
    const momentDate = moment()
    return {
      timeRange: [momentDate.subtract(7, 'days').format('YYYY-MM-DD'), momentDate.add(8, 'days').format('YYYY-MM-DD')],
      exporting: false,
      exportTaskId: null
    }
  },
  computed: {
    dialogShow: {
      get () {
        return this.show
      },
      set (val) {
        this.$emit('update:show', false)
      }
    },
    pickerOptions () {
      return {
        disabledDate (time) {
          return time.valueOf() > moment().add(1, 'days')
        }
      }
    }
  },
  created () {
  },
  methods: {
    ...mapActions('microSite', ['createMicrositeFormExportTask', 'getMicrositeFormExportData']),
    handelCancel () {
      this.dialogShow = false
    },
    async handelExport () {
      if (this.exporting) {
        return
      }
      this.exporting = true
      const params = {
        site_id: this.siteId,
        start_date: this.timeRange[0],
        end_date: this.timeRange[1]
      }
      const resp = await this.createMicrositeFormExportTask(params)
      if (resp && resp.task_id) {
        this.exportTaskId = resp.task_id
        setTimeout(this.getExportTask, 1000)
      }
    },
    async getExportTask () {
      if (!this.exportTaskId) {
        return
      }
      const resp = await this.getMicrositeFormExportData({ task_id: this.exportTaskId })
      if (resp) {
        if (!resp.is_finished) {
          setTimeout(this.getExportTask, 1000)
        } else {
          this.downLoadExportTask(this.exportTaskId)
          this.exportTaskId = null
          this.exporting = false
        }
      }
    },
    downLoadExportTask (taskId) {
      const fileName = encodeURIComponent(`${this.campaignName}_${this.micrositeName}_${this.timeRange[0]}-${this.timeRange[1]}.xlsx`)
      window.open(`/django_rest/crm/campaign/form/export/?download=1&task_id=${taskId}&file_name=${fileName}`)
    }
  },
  watch: {
  }
}
</script>

<style lang="scss" scoped>
.export-dialog {
  .dialog-container {
    .info-item {
      display: flex;
      font-size: 16px;
      align-items: center;
      height: 50px;

      .title {
        width: 30%;
        text-align: right;
        padding-right: 30px;
      }
      .name {
        width: 70%;
      }

      .date {
        width: 65%;
      }
    }
  }
}
</style>
